import { animate, animateChild, group, query, style, transition, trigger } from "@angular/animations";

export const panelRight = [
  trigger("panelRight", [
    transition("* <=> *", [
      group([
        query('@panelRightFade', [
          animateChild()
        ]),
        query('@panelRightSlide', [
          animateChild()
        ])
      ])
    ])
  ]),

  trigger('panelRightFade', [
    transition(':enter', [
      style({
        opacity: 0,
      }),
      animate(
        '.3s cubic-bezier(.32,.9,.9,.96)',
        style({
          opacity: '1',
        }),
      ),
    ]),
    transition(':leave', [
      style({
        opacity: '1',
      }),
      animate(
        '.3s .2s cubic-bezier(.32,.9,.9,.96)',
        style({
          opacity: 0,
        }),
      ),
    ]),
  ]),

  trigger('panelRightSlide', [
    transition(':enter', [
      style({
        transform: 'translateX(100%)',
      }),
      animate(
        '.6s .3s cubic-bezier(.16,.78,.26,.99)',
        style({
          transform: 'translateX(0)',
        }),
      ),
    ]),
    transition(':leave', [
      style({
        transform: 'translateX(0)',
      }),
      animate(
        '.4s cubic-bezier(.16,.78,.26,.99)',
        style({
          transform: 'translateX(100%)',
        }),
      ),
    ]),
  ])
]
